import { API, API_GET_P } from "../../Config";

export const GetUser = (count,usertype) => {
  console.log('object',usertype)
  return API_GET_P(API.user , count,usertype);
};
